import { ActionTypes } from '../constants/AppConstants';
import AppDispatcher from '../dispatcher/AppDispatcher';


const ReservationRequestActions = {
    setPassengers(passengers) {
        AppDispatcher.dispatch({
            actionType: ActionTypes.SET_RESERVATION_REQUEST_PASSENGERS,
            passengers,
        });
    },

    setRequestSeats(requestSeats) {
        AppDispatcher.dispatch({
            actionType: ActionTypes.SET_RESERVATION_REQUEST_SEATS,
            requestSeats,
        });
    },

    setOutboundService(journey) {
        AppDispatcher.dispatch({
            actionType: ActionTypes.SET_RESERVATION_REQUEST_OUTBOUND_SERVICE,
            journey,
        });
    },

    setInboundService(journey) {
        AppDispatcher.dispatch({
            actionType: ActionTypes.SET_RESERVATION_REQUEST_INBOUND_SERVICE,
            journey,
        });
    },

    setOutboundFare(fare) {
        AppDispatcher.dispatch({
            actionType: ActionTypes.SET_RESERVATION_REQUEST_OUTBOUND_FARE,
            fare,
        });
    },

    setInboundFare(fare) {
        AppDispatcher.dispatch({
            actionType: ActionTypes.SET_RESERVATION_REQUEST_INBOUND_FARE,
            fare,
        });
    },

    resetAllServicesAndFares() {
        AppDispatcher.dispatch({
            actionType: ActionTypes.RESET_RESERVATION_REQUEST_OUTBOUND_SERVICE,
        });
        AppDispatcher.dispatch({
            actionType: ActionTypes.RESET_RESERVATION_REQUEST_INBOUND_SERVICE,
        });
        AppDispatcher.dispatch({
            actionType: ActionTypes.RESET_RESERVATION_REQUEST_OUTBOUND_FARE,
        });
        AppDispatcher.dispatch({
            actionType: ActionTypes.RESET_RESERVATION_REQUEST_INBOUND_FARE,
        });
    },

    setBikes(bikesQty) {
        if (typeof bikesQty !== 'number' || bikesQty < 0) {
            console.error('Invalid bikesQty:', bikesQty);
            return;
        }

        AppDispatcher.dispatch({
            actionType: ActionTypes.SET_RESERVATION_REQUEST_BIKES,
            bikesQty,
        });
    },

    clearReservationRequestStore() {
        AppDispatcher.dispatch({
            actionType: ActionTypes.CLEAR_RESERVATION_REQUEST_STORE,
        });
    },
};

export default ReservationRequestActions;
